import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const toasted = {
  success: async function (message) {
    toast.success(message, {
      position: "bottom-right",
      autoClose: 3000,
      hideProgressBar: true,
      closeOnClick: false,
      pauseOnHover: false,
      draggable: false,
      progress: false,
      theme: "dark",
    });
  },

  error: async function (message) {
    toast.error(message, {
      position: "bottom-right",
      autoClose: 3000,
      hideProgressBar: true,
      closeOnClick: false,
      pauseOnHover: false,
      draggable: false,
      progress: false,
      theme: "dark",
    });
  },
};

export default toasted;
